import React, { useEffect, useState, useRef, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { FaPlay, FaPause } from "react-icons/fa";
import "./SkillSlider.css";

const SkillSlider = ({ data, variant = "primary" }) => {
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");
  const [isPaused, setIsPaused] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
    const handleTheme = () => setTheme(localStorage.getItem("theme") || "dark");
    window.addEventListener("themeChanged", handleTheme);
    return () => window.removeEventListener("themeChanged", handleTheme);
  }, []);

  const toggleAutoplay = () => {
      if (swiperRef.current?.autoplay) {
        if (isPaused) {
          // 1. On relance l'autoplay
          swiperRef.current.autoplay.start();
          // 2. On force le passage à la slide suivante IMMÉDIATEMENT
          swiperRef.current.slideNext();
        } else {
          // On met en pause
          swiperRef.current.autoplay.stop();
        }
        setIsPaused(!isPaused);
      }
    };
  
  // Transformation des données pour aplatir les catégories si nécessaire
  const flatData = useMemo(() => {
    if (variant === "primary" && data[0]?.skills) {
      return data.flatMap(cat => cat.skills.map(s => ({ ...s, category: cat.label })));
    }
    return data;
  }, [data, variant]);

  return (
    <div className={`skill-slider-wrapper ${theme === "light" ? "day-mode" : ""}`}>
      <Swiper
        onSwiper={(s) => (swiperRef.current = s)}
        modules={[Navigation, Pagination, Autoplay]}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 4500, disableOnInteraction: false }}
        loop
        centeredSlides={true}
        slidesPerView={"auto"}
      >
        {flatData.map((item, i) => (
          <SwiperSlide key={i}>
            <div className="skill-card">
              {item.category && <span className="skill-category">{item.category}</span>}
              <div className="skill-icon-wrapper">
                {item.icon ? <item.icon className="skill-icon" /> : <img src={item.image} alt={item.name} className="skill-image" />}
              </div>
              <h5 className="skill-name">{item.name}</h5>
              {item.libs && (
                <div className="skill-footer">
                  {item.libs.map((lib, idx) => <span key={idx} className="skill-badge">{lib}</span>)}
                </div>
              )}
              {item.desc && <p className="skill-desc">{item.desc}</p>}
            </div>
          </SwiperSlide>
        ))}

        <div className="swiper-controls-wrapper">
          <button className="play-pause-btn" onClick={toggleAutoplay}>
            {isPaused ? <FaPlay /> : <FaPause />}
          </button>
        </div>
      </Swiper>
    </div>
  );
};

export default SkillSlider;